import { PERMISSIONS } from '@/libs/acl/permissions'

export default [
  {
    path: '/apps/wms/locations',
    name: 'warehouse-location',
    component: () => import('@/views/apps/warehouse-management/Locations.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_WMS,
      action: 'read',
      pageTitle: 'Set up Locations',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'WMS',
        },
        {
          text: 'Set up Locations',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/wms/actions',
    name: 'warehouse-action',
    component: () => import('@/views/apps/warehouse-management/Actions.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_WMS,
      action: 'read',
      pageTitle: 'Location Actions',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'WMS',
        },
        {
          text: 'Location Actions',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/wms/actions/move-batch/:moveBatchId?',
    name: 'warehouse-move-batch',
    component: () => import('@/views/apps/warehouse-management/view/MoveBatchItem.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_WMS,
      action: 'read',
      pageTitle: 'Location Actions',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'WNS',
        },
        {
          text: 'Location Actions',
          to: '/apps/wms/actions',
        },
        {
          text: 'Move Batch',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/wms/location/lpn',
    name: 'warehouse-location-lpn',
    component: () => import('@/views/apps/warehouse-management/view/LpnLocation.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_WMS,
      action: 'read',
      pageTitle: 'LPN Actions',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'LPN Actions',
        },
        {
          text: 'Actions',
          to: '/apps/wms/actions',
        },
        {
          text: 'LPN',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apps/wms/actions/location-barcode-designer',
    name: 'location-barcode-designer',
    component: () => import('@/views/apps/warehouse-management/view/BarcodeDesigner.vue'),
    meta: {
      resource: PERMISSIONS.RESOURCE_WMS,
      action: 'read',
      pageTitle: 'Label Designer',
      breadcrumb: [
        {
          text: 'Home',
          to: '/dashboard',
        },
        {
          text: 'Management',
        },
        {
          text: 'WMS',
        },
        {
          text: 'Label Designer',
          active: true,
        },
      ],
    },
  },
]
